var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#CB998D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 11H17L15 9H9C7.9 9 7.01 9.9 7.01 11L7 23C7 24.1 7.9 25 9 25H25C26.1 25 27 24.1 27 23V13C27 11.9 26.1 11 25 11ZM25 23H9V13H25V23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.d1856c5cec8866ddc777ca4a79614a1c.svg";
export { ForwardRef as ReactComponent };